import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';

@Injectable()
export class BatchLineService extends ApiService {
  constructor(private http: Http) {
    super('api/batch-lines/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/batch-line.service.ts